import type { Order } from "@jti/magento";

export const checkIsTradeInPurchase = (order?: Order) => {
  if (!order?.additional_attributes) {
    return false;
  }

  return order.additional_attributes.some(
    (attribute) => attribute.attribute_code === "traded_in_new_sku" && Boolean(attribute.value)
  );
};
